export { BookService } from './book/book.service';
export { ChaptersService } from './chapters/chapters.service';
export { CheckinService } from './checkin/checkin.service';
export { ProtocolService } from './protocol/protocol.service';
export { AssignmentService } from './assignment/assignment.service';
